export const DEFAULT_COUNTRY_DIAL_CODE = '49'; // Country dial code for Germany
export const DEFAULT_COUNTRY_CODE = 'DE';

export const DEFAULT_MAX_ADDITIONAL_DOCS_ALLOWED = 2;

export const CLASS_NAME_RECENT_CV_BANNERS_WRAPPER = 'recent-cv-banners-wrapper';
